import { createEntityAdapter } from '@reduxjs/toolkit';
import { IValveGridEdit } from 'application/editcomp/api/ValveConnectorGrid/ValveGridEdit';

export const valveGridEditAdapter = createEntityAdapter<IValveGridEdit, number>({
  selectId: (project) => project.valveGridID,
  sortComparer: (a, b) => a.name.localeCompare(b.name),
});
